export const addMonths = (date: Date, months: number) => {
  const newDate = new Date(date.getTime());
  newDate.setMonth(date.getMonth() + months);
  return newDate;
};

export const isDialogOpened = () => document.querySelectorAll('[role="dialog"]');
